import { render, staticRenderFns } from "./Gbm-Header.vue?vue&type=template&id=75d98816&"
import script from "./Gbm-Header.vue?vue&type=script&lang=js&"
export * from "./Gbm-Header.vue?vue&type=script&lang=js&"
import style0 from "./Gbm-Header.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Gbm-Header.vue"
export default component.exports